import React from "react";

import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { ValidationIcon } from "../../__components__/icons";

function ValidationSection({ selectedStars }) {
    return (
        <div className="ek-chat__satisfaction--validation">
            <div className="ek-chat__satisfaction--validation--icon">
                <ValidationIcon />
            </div>
            {selectedStars > 0.6 ? (
                <span className="ek-chat__satisfaction--validation--text">
                    <FormattedMessage
                        id="WEBMESSENGER.CONVERSATION.VISITOR_SATISFACTION_RATE_HIGH"
                        defaultMessage="Merci pour votre confiance"
                    />
                </span>
            ) : (
                <span className="ek-chat__satisfaction--validation--text">
                    <FormattedMessage
                        id="WEBMESSENGER.CONVERSATION.VISITOR_SATISFACTION_RATE_LOW"
                        defaultMessage="Nous prenons en compte votre retour pour nous améliorer"
                    />
                </span>
            )}
        </div>
    );
}

ValidationSection.propTypes = {
    selectedStars: PropTypes.number,
};

ValidationSection.defaultProps = {
    selectedStars: null,
};

export default ValidationSection;
